import { AttributeType, SugarAttributeInfo } from "../../SugarElementInfo";

export const classNameAttribute: SugarAttributeInfo = {
    name: "className",
    valueTypes: [AttributeType.CssClassName],
};
